module.exports = "/assets/data/ee5de0aa82a5bd1be578a2ae547d7810-B71.data.json";